import { Core } from "@faire/design-tokens";
import { EmailSentScenario } from "@faire/retailer-visitor-shared/components/AppSignIn/components/EmailSentWaitingView";
import { AllResult } from "@faire/retailer-visitor-shared/components/AppSignIn/components/SignInController";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { trackSigninCheckEmailEnterCodeClick } from "@faire/web-api--source/events/signin/click/checkEmailEnterCode";
import { MfaMethod } from "@faire/web-api--source/indigofair/data/MfaMethod";
import { Button } from "@faire/web/slate/Button";
import { HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import type { JSX } from "react";

export const CommonFooter: React.FC<{
  email: string;
  scenario: EmailSentScenario;
  onComplete: (result: AllResult) => void;
  password?: string;
}> = ({ onComplete, email, scenario, password }) => {
  return (
    <>
      <HorizontalLine />
      <Spacer size="3x" />
      <Typography color={Core.text.subdued}>
        <StrictLocalMsg
          id="qfDMlv"
          defaultMessage="Using another device to sign in? <LinkFormatting>Enter code</LinkFormatting>"
          description={{
            text: "Prompt for the user to enter a code if they are using another device to sign in",
          }}
          values={{
            LinkFormatting: LinkFormatting(() => {
              trackSigninCheckEmailEnterCodeClick(scenario);
              onComplete(
                scenario === EmailSentScenario.AUTO
                  ? {
                      nextView: View.ENTER_CODE,
                      email,
                    }
                  : {
                      nextView: View.ENTER_MFA_CODE,
                      email,
                      mfaMethod: MfaMethod.EMAIL_ADDRESS,
                      mfaTitle: "",
                      mfaDescription: "",
                      password: password,
                    }
              );
            }),
          }}
        />
      </Typography>
    </>
  );
};

const LinkFormatting = (onClick: () => void) =>
  function (chunks: JSX.Element) {
    return (
      <Button variant="tertiary" onClick={onClick} tertiaryColor="inherit">
        {chunks}
      </Button>
    );
  };
